/**
 * Public Telegram job channel (`@lokerdollarjobs`). Identifiers only, never a
 * credential: the bot token lives in the `TELEGRAM_USER_BOT_TOKEN` secret
 * (Secrets Store binding `TELEGRAM_USER_BOT_TOKEN_STORE` on the backend
 * worker). Imported by client link components too, so keep this file free of
 * server-only imports.
 */

/** PostHog flag, sole switch for the posting cron AND every on-site link. */
export const TELEGRAM_JOB_CHANNEL_FLAG = "telegram-job-channel";

export const TELEGRAM_JOB_CHANNEL_HANDLE = "lokerdollarjobs";

/** Numeric chat id of the public channel (bot is admin with post rights). */
export const TELEGRAM_JOB_CHANNEL_CHAT_ID = "-1004492017523";

/** Join link shown on site and in email. */
export const TELEGRAM_JOB_CHANNEL_URL = `https://t.me/${TELEGRAM_JOB_CHANNEL_HANDLE}`;

/** Public web preview of the channel, scraped once a day for view counts. */
export const TELEGRAM_JOB_CHANNEL_PREVIEW_URL = `https://t.me/s/${TELEGRAM_JOB_CHANNEL_HANDLE}`;
